<template>
    <path d="M12 2.91A9.09 9.09 0 0 0 2.91 12 9.09 9.09 0 0 0 12 21.09 9.09 9.09 0 0 0 21.09 12 9.09 9.09 0 0 0 12 2.91zm-1.22 1.883h2.436a.367.367 0 0 1 .366.366V7.13a.367.367 0 0 1-.366.366h-2.435a.367.367 0 0 1-.367-.366V5.16a.367.367 0 0 1 .367-.367zm-1.5 4.19h3.933a.366.366 0 0 1 .366.366v1.788a.58.58 0 0 1 .003.061v4.174h.919a.561.561 0 0 1 .56.56v1.622a.561.561 0 0 1-.56.56h-5a.561.561 0 0 1-.56-.56v-1.622a.561.561 0 0 1 .56-.56h.913V11.66H9.28a.366.366 0 0 1-.366-.366V9.349a.366.366 0 0 1 .366-.365z"/>
</template>

<script>
    export default {
        name: 'info',
    }
</script>



// WEBPACK FOOTER //
// src/components/icon/Info.vue